// @ts-strict-ignore
import type { Action } from 'flow/store/engine/types';


// todo - move this to the outcome service layer
// the sort order of this function should match the one at `layout.ts/sorting.ts/sortIslandNodesByPrecedenceIndex`
export function sortOutcomeActionsByPrecedenceIndex(outcomeActions: Action[]) {
  return outcomeActions.sort((a, b) => b.outcome.precedenceIndex - a.outcome.precedenceIndex);
}
